<template>
  <div class="row-edit">
    <span v-if="!noEdit" class="edit" v-show="isEdit">
      <el-input
        v-if="type === 'input'"
        ref="ipt"
        class="row-ipt"
        v-model="fieldVal"
        :maxlength="maxlength"
        :disabled="loading"
        placeholder="请输入"
      >
      </el-input>
      <el-select v-else v-model="fieldVal">
        <el-option
          ref="ipt"
          v-for="item in options"
          :key="item.value"
          :value="item.value"
          :label="item.label"
          >{{ item.label }}</el-option
        >
      </el-select>
      <i v-show="loading" class="el-icon-loading"></i>
      <i v-show="!loading" class="el-icon-check" @click="handleUpdate"></i>
      <i v-show="!loading" class="el-icon-close" @click="isEdit = false"></i>
    </span>
    <span v-show="!isEdit" :class="!noEdit && 'row-content'" @click="toEdit">
      <span :style="textStyle">{{ transValue }}</span>
      <i v-if="!noEdit && (transValue || transValue === 0)" class="el-icon-edit"></i>
      <span v-if="!noEdit && !transValue && transValue !== 0" class="edit-text">编辑</span>
    </span>
  </div>
</template>

<script>
import { getRequest, postRequest } from "@/api/matrixApi";

export default {
  name: "row-edit",
  model: {
    event: "onUpdate",
  },
  props: {
    value: [String, Number], // 当前值
    fieldName: String, // 需要修改的字段名
    editUrl: String, // 修改接口地址
    row: Object, // 行信息
    // 接口方法，默认 post (目前只支持 post 和 get)
    method: {
      type: String,
      default: "post",
    },
    maxlength: {
      type: [Number, String],
      default: 25,
    },
    paramsRow: Boolean, // params 传值是否为 row
    customParams: Object, // 自定义其他查询参数
    validate: Function, // 提交校验
    textStyle: Object, // 展示样式
    noEdit: Boolean, // 不修改
    type: {
      type: String,
      default: "input",
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isEdit: false,
      fieldVal: "",
      loading: false,
    };
  },
  computed: {
    transValue() {
      if (this.type === "select") {
        const selected = this.options.find((o) => o.value === this.value);
        if (selected) {
          return selected.label;
        }
      }
      return this.value;
    },
  },
  methods: {
    toEdit() {
      if (this.noEdit) return;
      this.isEdit = true;
      this.$nextTick(() => {
        this.$refs.ipt.focus();
      });
    },
    handleUpdate() {
      const {
        row,
        row: { id },
        fieldName,
        fieldVal,
        paramsRow,
        customParams,
      } = this;
      if (this.validate && !this.validate(fieldVal, fieldName)) return;
      const params = paramsRow
        ? { ...row, [fieldName]: fieldVal, ...customParams }
        : { id, [fieldName]: fieldVal, ...customParams };
      this.toRequest(params)
        .then((res) => {
          if (res.code !== 200) return this.$message.error(res.msg);
          this.isEdit = false;
          this.$emit("onUpdate", fieldVal);
        })
        .finally(() => (this.loading = false));
    },
    toRequest(params) {
      this.loading = true;
      return this.method === "post"
        ? postRequest(this.editUrl, params)
        : getRequest(this.editUrl, params);
    },
  },
  watch: {
    isEdit(val) {
      if (val) this.fieldVal = this.deepClone(this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.row-edit {
  .edit {
    display: flex;
    align-items: center;

    ::v-deep i {
      font-size: 16px;
    }
  }
  .row-ipt {
    width: 65%;

    ::v-deep .el-input__inner {
      padding: 0;
    }
  }

  ::v-deep i {
    cursor: pointer;
  }

  .row-content {
    cursor: pointer;
  }

  .edit-text {
    color: #DD1144;
  }
}
</style>
